import React from 'react';
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {TableRow} from "../../../core/components/table/table-row";
import {ScoreboardWidgetCompetitorViewModel} from "../models/scoreboard-widget.competitor-view-model";
import {ScoreboardWidgetScoreCellViewModel} from "../models/scoreboard-widget.score-cell-view-model";
import {ScoreboardWidgetScoreCell} from "./scoreboard-widget.score-cell";
import {ScoreboardWidgetCompetitorCell} from "./scoreboard-widget.competitor-cell";

export class ScoreboardWidgetRowProps extends BaseProps {
  competitor: ScoreboardWidgetCompetitorViewModel;
  isEven: Boolean;
}

export const ScoreboardWidgetCompetitorTableRow = (props: ScoreboardWidgetRowProps) => {
  const className = ['scoreboard-widget-competitor-table-row', props.isEven ? 'scoreboard-widget-competitor-table-row-even' : 'scoreboard-widget-competitor-table-row-odd'].join(' ');

  return (
    <TableRow className={className}>
      {
        props.competitor ?
          <>
            <ScoreboardWidgetCompetitorCell competitor={props.competitor}/>
            {
              props.competitor?.cells?.map((cell: ScoreboardWidgetScoreCellViewModel, index: Number) =>
                <ScoreboardWidgetScoreCell key={index} cell={cell}/>)
            }
          </> : null
      }
    </TableRow>
  )
}
